import { Component, EventEmitter, Input, Output } from "@angular/core";

export type BannerType = "risco-zero" | "default" | "intercompany";

@Component({
    selector: "app-operation-banner",
    templateUrl: "./risco-zero-banner.component.html",
    styleUrls: ["./risco-zero-banner.component.scss"],
})
export class OperationBannerComponent {
    @Input() bannerType: BannerType = "risco-zero";
    @Output() followConventional = new EventEmitter<void>();
    @Output() followExpress = new EventEmitter<void>();

    private readonly EXPRESS_TITLE = "O fluxo Express resolve isso em minutos.";
    private readonly EXPRESS_DESCRIPTION = "Recomendamos que siga pelo fluxo ideal para operações desse tipo.";
    private readonly BENEFIT_FAST = "Ele é mais rápido e foi desenhado especialmente para esse tipo de operação.";
    private readonly BENEFIT_AUTO_SIGNATURE =
        "Envio automático para assinatura do cedente logo após a criação da operação.";
    private readonly BENEFIT_RISCO_ZERO =
        "Não inclui análise de crédito, sacados ou operações com Funding, mas atende perfeitamente operações Risco Zero.";
    private readonly BENEFIT_DEFAULT = "Fluxo otimizado para operações padrão com processamento mais ágil.";
    private readonly BENEFIT_INTERCOMPANY =
        "Processamento simplificado para operações Intercompany com validações específicas.";

    get identificationMessage(): string {
        const messages = {
            riscoZeroAndDefault: "Olá, identificamos uma operação de Risco Zero.",
            intercompany: "Olá, identificamos uma operação Intercompany.",
        } as const;
        switch (this.bannerType) {
            case "risco-zero":
            case "default":
                return messages.riscoZeroAndDefault;
            case "intercompany":
                return messages.intercompany;
            default:
                return messages.riscoZeroAndDefault;
        }
    }

    get expressTitle(): string {
        return this.EXPRESS_TITLE;
    }

    get expressDescription(): string {
        return this.EXPRESS_DESCRIPTION;
    }

    get benefits(): string[] {
        const commonBenefits = [this.BENEFIT_FAST, this.BENEFIT_AUTO_SIGNATURE];

        switch (this.bannerType) {
            case "risco-zero":
                return [...commonBenefits, this.BENEFIT_RISCO_ZERO];
            case "default":
                return [...commonBenefits, this.BENEFIT_DEFAULT];
            case "intercompany":
                return [...commonBenefits, this.BENEFIT_INTERCOMPANY];
            default:
                return commonBenefits;
        }
    }

    onFollowConventional(): void {
        this.followConventional.emit();
    }

    onFollowExpress(): void {
        this.followExpress.emit();
    }
}
